//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "DragRightCaptcha",
  props: {
    visible: { type: Boolean, default: false },
    tipText: { type: String, default: "安全驗證" }
  },
  data() {
    return {
      percent: 0,
      trackPoints: [],
      startTime: 0,
      dragging: false,
      failed: false,
      successFlash: false,
      trackWidth: 0,
      thumbOffset: 0,
      fillWidth: 0,
      thumbSize: 0,
      trackPad: 0,
      barWidth: 0
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.reset();
        this.lockScroll(true);
        this.$nextTick(this.measureTrack);
      } else {
        this.lockScroll(false);
      }
    }
  },
  methods: {
    reset() {
      this.percent = 0;
      this.trackPoints = [];
      this.startTime = 0;
      this.dragging = false;
      this.failed = false;
      this.successFlash = false;
      this.thumbOffset = 0;
      this.fillWidth = this.trackPad + this.thumbSize;
    },
    lockScroll(lock) {
      document.body.style.overflow = lock ? "hidden" : "";
    },
    onClose() {
      this.reset();
      this.lockScroll(false);
      this.$emit("close");
    },
    measureTrack() {
      var bar = this.$refs.trackBar;
      var thumb = this.$refs.thumb;
      if (!bar || !thumb) {
        return;
      }
      var barRect = bar.getBoundingClientRect();
      var thumbRect = thumb.getBoundingClientRect();
      this.barWidth = barRect.width;
      this.thumbSize = thumbRect.width;
      this.trackPad = Math.max(thumbRect.left - barRect.left, 0);
      this.trackWidth = Math.max(barRect.width - this.thumbSize - this.trackPad, 1);
      this.updateFillWidth();
    },
    updateFillWidth() {
      this.fillWidth = Math.min(this.barWidth, this.trackPad + this.thumbOffset + this.thumbSize);
    },
    getTouch(e) {
      return e.touches ? e.touches[0] : e;
    },
    updateByClientX(clientX) {
      var bar = this.$refs.trackBar;
      if (!bar) {
        return;
      }
      var rect = bar.getBoundingClientRect();
      var offset = clientX - rect.left - this.trackPad - this.thumbSize / 2;
      offset = Math.max(0, Math.min(this.trackWidth, offset));
      this.thumbOffset = offset;
      this.updateFillWidth();
      this.percent = offset / this.trackWidth;
      this.recordPoint(this.percent);
    },
    onStart(e) {
      this.failed = false;
      this.successFlash = false;
      this.dragging = true;
      this.startTime = Date.now();
      this.trackPoints = [];
      this.measureTrack();
      this.updateByClientX(this.getTouch(e).clientX);
      document.addEventListener("touchmove", this.onMove, { passive: false });
      document.addEventListener("mousemove", this.onMove);
      document.addEventListener("touchend", this.onEnd);
      document.addEventListener("mouseup", this.onEnd);
    },
    onMove(e) {
      if (!this.dragging) {
        return;
      }
      e.preventDefault();
      this.updateByClientX(this.getTouch(e).clientX);
    },
    onEnd() {
      if (!this.dragging) {
        return;
      }
      this.dragging = false;
      document.removeEventListener("touchmove", this.onMove);
      document.removeEventListener("mousemove", this.onMove);
      document.removeEventListener("touchend", this.onEnd);
      document.removeEventListener("mouseup", this.onEnd);

      this.recordPoint(this.percent);

      if (this.percent >= 0.95) {
        this.successFlash = true;
        this.percent = 1;
        this.thumbOffset = this.trackWidth;
        this.fillWidth = this.barWidth;
        var trackData = {
          startMs: this.startTime,
          points: this.trackPoints
        };
        var payload = {
          finalPercent: 1,
          track: JSON.stringify(trackData)
        };
        var self = this;
        setTimeout(function () {
          self.$emit("solved", payload);
          self.lockScroll(false);
          self.reset();
        }, 280);
      } else {
        this.failed = true;
        var self2 = this;
        setTimeout(function () {
          self2.percent = 0;
          self2.thumbOffset = 0;
          self2.fillWidth = self2.trackPad + self2.thumbSize;
          self2.trackPoints = [];
          self2.failed = false;
        }, 650);
      }
    },
    recordPoint(x) {
      this.trackPoints.push({
        t: Date.now(),
        x: x,
        y: 0
      });
    }
  },
  beforeDestroy() {
    this.lockScroll(false);
    document.removeEventListener("touchmove", this.onMove);
    document.removeEventListener("mousemove", this.onMove);
    document.removeEventListener("touchend", this.onEnd);
    document.removeEventListener("mouseup", this.onEnd);
  }
};



// WEBPACK FOOTER //
// ./src/components/DragRightCaptcha.vue